import {
  DisplayType,
  FieldTypeEnum,
  KeyValueFormattingModel,
  KeyValueRestrictionModel,
} from '@models/module/fields/enums';
import { AttachmentModel } from '@models/module/fields/main/attachment.model';
import { AppColors } from '@shared/consts';
import { AddressModel } from './address.model';

export interface FormFieldModel<V = FormFieldValueType> {
  id: number;
  name?: string;
  label?: string;
  hasMultipleValues?: boolean;
  type?: FieldTypeEnum;
  displayType?: DisplayType;
  restrictions?: KeyValueRestrictionModel[];
  formattings?: KeyValueFormattingModel[];
  isSystem?: boolean;
  isMandatory?: boolean;
  inUse?: boolean;
  fieldOrigin?: FieldOrigin;
  x?: number;
  y?: number;
  cols?: number;
  rows?: number;
  /* ids of fields triggered by this field's formula */
  triggeredFields?: number[];
  value?: V;
  isFilter?: boolean;
  aggregateValue?: Record<number, string>;
  expression?: unknown;
  weatherDateId?: number;
  weatherLocationId?: number;
  screensId?: number[];
  usedOnWeather?: boolean;
  relationId?: number;
  annotation?: string;
  actionInstanceId?: number;
  previousActionInstanceId?: number;
  dataSourceId?: number;
  dataSources?: FieldDataSourceModel[];
  systemFieldName?: string;

  /* Used for related lists */
  isParent?: boolean;
  parentHasDefaultValue?: boolean;
  childFieldIds?: number[];
  parentFieldIds?: number[];

  //   Defined in FE
  bgColor?: AppColors;

  // will remove these
  currentDateTime?: boolean;
  typeId?: number;
  displayTypeId?: number;
}

export interface FieldDataSourceModel {
  isDisabled: boolean;
  key: string;
  value: string;
  order: number;
}

export enum FieldOrigin {
  /** Fields that are used in start screen</summary> */
  Property = 1,
  /** Fields that are relation type */
  Relation = 2,
  /** Fields that are used in action screen */
  Local = 3,
}

export type BaseFieldValueType =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | AttachmentModel
  | AttachmentModel[]
  | AddressModel
  | AddressModel[];
export type TableFieldValueType = Record<string, BaseFieldValueType>;

export type FormFieldValueType = BaseFieldValueType | TableFieldValueType[];
export type FormValueType = Record<string, FormFieldValueType>;
